<template>
    <div class="factoring-carrier-list">
      <h2 class="title">
        Carriers pending approval
      </h2>
      <carrier-approvals />
    </div>
</template>

<script>
import CarrierApprovals from '@/components/FactoringApprovalsCarrierTable'
export default {
  name: 'Factoring',

  data() {
    return {
      list: [
        'The Coca-Cola Company',
        'Amazon.com, Inc',
        'Apple Inc.',
        'Dark Horse Brewery',
        'Canal Street Brewing Co., L.L.C.',
        'Gordon Food Service',
        'Walmart Inc.'
      ]
    }
  },

  components: {
    CarrierApprovals
  },

  methods: {
    getRandomInt(min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min)) + min //The maximum is exclusive and the minimum is inclusive
    }
  }
}
</script>

<style scoped lang="scss">
.factoring-carrier-list {
  min-height: 85vh;
  &::after {
    // TODO: this would be great as a mix-in
    content: '';
    background-image: url('../../assets/backgrounds/shutterstock_583622419.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 0.4;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
    z-index: -1;
  }
}
.button {
  margin: 0 16px;
}
</style>
